import React from 'react';
import PropTypes from 'prop-types';

import { compact } from 'lodash';
import { FormGroup, Modal } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';

const getGroupId = (group) => {
  return group.id && group.id.toString();
};

export default class GroupFormModal extends React.Component {
  static propTypes = {
    group: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }),
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })),
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  }

  state = {
    namesByGroupId: {}
  }

  get title() {
    const group = this.groups[0] || {};

    if (group.id) {
      const groupWord = this.groups.length === 1 ? 'Group' : 'Groups';
      return `Edit ${groupWord}`;
    } else {
      return 'Create New Group';
    }
  }

  get groups() {
    return this.props.groups || compact([this.props.group]);
  }

  canSave() {
    return Object.values(this.state.namesByGroupId).every(name => name);
  }

  handleShow = () => {
    const namesByGroupId = {};
    for (const group of this.groups) {
      namesByGroupId[getGroupId(group)] = group.name;
    }

    this.setState({ namesByGroupId });
  }

  handleChange = (changes) => {
    this.setState(state => ({ namesByGroupId: { ...state.namesByGroupId, ...changes } }));
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const groups = this.groups.map(group => ({
      ...group,
      name: this.state.namesByGroupId[getGroupId(group)]
    }));

    if (this.props.group) {
      this.props.onSubmit(groups[0]);
    } else {
      this.props.onSubmit(groups);
    }
  }

  render() {
    return (
      <Modal show={this.props.shown} onHide={this.props.onCancel} onShow={this.handleShow}>
        <Modal.Header closeButton>
          <Modal.Title>{this.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={this.handleSubmit}>
            {this.renderNameInputs()}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-sm btn-cancel"
            name="cancel"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-sm btn-save"
            disabled={!this.canSave()}
            name="save"
            onClick={this.handleSubmit}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderNameInputs() {
    return this.groups.map(group => this.renderNameInput(group));
  }

  renderNameInput(group) {
    return (
      <FormGroup key={group.id}>
        <ManagedInput
          className="form-control"
          name={getGroupId(group)}
          placeholder="Name"
          value={this.state.namesByGroupId[group.id]}
          onChange={this.handleChange}
        />
      </FormGroup>
    );
  }
}
